import { render } from "./UnderConstruction.vue?vue&type=template&id=f0758872&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=f0758872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0758872"]])

export default __exports__